// extracted by mini-css-extract-plugin
module.exports = {"header":"Components_header__2FPJs","link":"Components_link__d9w-I","activeLink":"Components_activeLink__1Cpn6"};